import React, { useEffect } from 'react'
import './projectlog.css'
import linkArrow from '../../asset/arrowRight.svg'
import { Link } from 'react-router-dom'

export const ProjectLog = () => {
  useEffect(() => {
    window.scrollTo(0, 0)

  }, [])
  
  return (
    <div className="projectLogContainer">
      <div id='projectLog' className='projectLog'>
        <div id='PJleft' className="left">
          <h1 className='projectLogHeader'>
            OUR<br />
            WORKS
          </h1>
          <p className='projectLogHeaderDes'>
            SOMEONE'S DREAM
          </p>
        </div>
        <div className="right">
          <p>We create showcase websites, activations, campaigns, digital experiences, apps, digital installations, progressive web apps (PWA), AR experiences, filters, lenses, 360° live games, swipe-ups, and more.</p>
          <p>We don’t sell ready-made templates or formulas, but unique craft, original adventures that will captivate your audiences. In other words: we code web-based journeys.</p>
        </div>
      </div>
      <section className="work" id='workSection'>
        <div id='workContainer' className="workContainer">
          <Link to='works' className="workLinks">
            <div id='cardContainer' className="cardContainer">
              <div id='cardArrow' className="cardArrow">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path></svg>
              </div>
              <div id='cardTitle' className="cardTitle">
                <p>Rosvar</p>
              </div>
                <div id='imgAnimHideDiveBig' className="imgAnimHideDiveBig">
                  <div id='cardImg' className="cardImg">
                    <img src="https://res.cloudinary.com/neuvieme-page/image/upload/w_800,q_auto:good,f_auto/v1644400347/studio-9p/uploads/image-cover-fooding.jpg" alt="" />
                  </div>
                </div>
            </div>
          </Link>


          <Link to='works' className='workLinks'>
          <div id='cardContainer2' className="cardContainer2">
            <div id='cardArrow2' className="cardArrow2">
            <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#8DFFA8" stroke-width="1.5" stroke-miterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#8DFFA8" stroke-width="1.5" stroke-miterlimit="10"></path></svg>
            </div>
            <div id='cardTitle' className="cardTitle2">
              <p>Rosvar</p>
            </div>
            <div id='imgAnimHideDive' className="imgAnimHideDive">
              <div id='cardImg' className="cardImg2">
                <img src="https://res.cloudinary.com/neuvieme-page/image/upload/w_800,q_auto:good,f_auto/v1644400347/studio-9p/uploads/image-cover-fooding.jpg" alt="" />
              </div>
            </div>
          </div>
          </Link>

    	    <Link to='works' className='workLinks'>
            <div id='cardContainer3' className="cardContainer3">
              <div id='cardArrow3' className="cardArrow3">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#8DFFA8" stroke-width="1.5" stroke-miterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#8DFFA8" stroke-width="1.5" stroke-miterlimit="10"></path></svg>
              </div>
              <div id='cardTitle' className="cardTitle3">
                <p>Rosvar</p>
              </div>
              <div id='imgAnimHideDiveBig' className="imgAnimHideDiveBig">
                <div id='cardImg' className="cardImg3">
                  <img src="https://res.cloudinary.com/neuvieme-page/image/upload/w_800,q_auto:good,f_auto/v1644400347/studio-9p/uploads/image-cover-fooding.jpg" alt="" />
                </div>
              </div>
            </div>
          </Link>

          <Link to='works' className='workLinks'>
            <div id='cardContainer4' className="cardContainer4">
              <div id='cardArrow4' className="cardArrow4">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#E1FF31" stroke-width="1.5" stroke-miterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#E1FF31" stroke-width="1.5" stroke-miterlimit="10"></path></svg>
              </div>
              <div id='cardTitle' className="cardTitle4">
                <p>Rosvar</p>
              </div>
              <div id='imgAnimHideDive' className="imgAnimHideDive">
                <div id='cardImg' className="cardImg4">
                  <img src="https://res.cloudinary.com/neuvieme-page/image/upload/w_800,q_auto:good,f_auto/v1644400347/studio-9p/uploads/image-cover-fooding.jpg" alt="" />
                </div>
              </div>
            </div>
          </Link>
          
        </div>
        <div id='dLinkW' className="dLinkW">
          <Link to='works' id='detailLinks' className='detailLinks' >Load More Works <img src={linkArrow} alt="" /></Link>
        </div>
      </section>

    </div>
  )
}
